import utilsType from './type.js'
// 生成uuid by shw
const createUUID = function () {
	let myDate = new Date()
	let myM = myDate.getMinutes()
	let myS = myDate.getSeconds()
	let myMS = myDate.getMilliseconds()
	let random = Math.round(Math.random() * 10000)
	return `fxCreateParams${myM}${myS}${myMS}${random}`
}
// 模糊查询string shw
const fuzzyQueryString = function (val, key) {
	if (Array.isArray(val)) {
		return ~(val.findIndex(item => {
			return fuzzyQueryString(item, key)
		}))
	} else {
		return (val || '').toLowerCase().includes((key || '').toLowerCase())
	}
}
// 模糊查询obj by shw
const fuzzyQueryObj = function (val, key, props) {
	return !!props.find(item => {
		if (~item.indexOf('.') && typeof val === 'object') {
			return fuzzyQuery(val, key, item)
		}
		return fuzzyQueryString(val[item], key)
	})
}
const fuzzyQuery = function (val, key, searchKey) {
	if (~searchKey.indexOf('.') && utilsType.toRawType(val) === 'Object') {
		const searchKeys = searchKey.split('.')
		const firstKey = searchKeys.shift()
		const otherKey = searchKeys.join('.')
		const _val = val[firstKey]
		if (Array.isArray(_val)) {
			return _val.some(item => {
				return fuzzyQuery(item, key, otherKey)
			})
		} else if (utilsType.toRawType(_val) === 'Object') {
			return fuzzyQuery(_val, key, otherKey)
		} else {
			return fuzzyQueryString(_val, key)
		}
	} else {
		return fuzzyQueryString(val[searchKey], key)
	}
}
export default {
	createUUID,
	fuzzyQueryObj,
	fuzzyQueryString
}



// WEBPACK FOOTER //
// ./src/lib/util/src/utils.js